// src/lib/journalStreak.js
// Journal streak maths, shared by the publisher (Timothy) and the viewer (Paul).
// A day counts as journaled when its dailyEntries record has hasEdits or practiceNotes.
import { formatDate } from '@/utils/helpers';

export const isJournaled = (e) => !!(e && (e.hasEdits || e.practiceNotes?.trim()));

const prevDay = (key) => {
  const d = new Date(`${key}T12:00:00`);
  d.setDate(d.getDate() - 1);
  return formatDate(d);
};

/** Consecutive journaled days ending today (or yesterday, if today is not written yet). */
export function computeJournalStreak(entries, todayKey) {
  const map = entries && typeof entries === 'object' ? entries : {};
  let cursor = isJournaled(map[todayKey]) ? todayKey : prevDay(todayKey);
  let streak = 0;
  let lastDate = null;
  while (isJournaled(map[cursor])) {
    if (!lastDate) lastDate = cursor;
    streak += 1;
    cursor = prevDay(cursor);
  }
  return { streak, lastDate };
}

/** A published streak is only still alive if it ended today or yesterday. */
export function effectiveStreak(streak, lastDate, todayKey) {
  if (!streak || !lastDate) return 0;
  return lastDate === todayKey || lastDate === prevDay(todayKey) ? streak : 0;
}